import React, { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Container, Draggable } from 'react-smooth-dnd';
import ReactTooltip from 'react-tooltip';

import s from './Board.module.css';
import cls from '../../../styles/index.module.css';
import { reOrderWarehousePosition, loadEquipmentData } from '../../store/slices/boardSlice';
import { setCurrencyValue } from '../../store/slices/inventorySlice';
import { setAccessValue } from '../../store/slices/restrictionsSlice';
import { loadWarehouseTotalInfo } from '../../store/slices/warehouseTotalInfoSlice';
import { AddWarehouseButtonContainer } from '../AddWarehouseButton/AddWarehouseButton';
import { BoardHeader } from '../BoardHeader/BoardHeader';
import { MoveInventoryItemQuantityModal } from '../MoveInventoryItemQuantityModal/MoveInventoryItemQuantityModal';
import Toast from '../Toast/Toast';
import { WarehouseContainer } from '../Warehouse/Warehouse';

const warehouseDropPlaceholder = { className: s.dropPlaceholder };

class BoardTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDataLoaded: false,
        };
        this.onWarehouseDrop = this.onWarehouseDrop.bind(this);
    }

    componentDidMount() {
        fetch(routable.getRoute('loadEquipmentData'), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                this.props.onEquipmentDataLoaded({ data });
                this.props.setCurrency(data.response.currency.sign);
                this.props.setAccess(data.response.restrictions.has_full_access);
                this.props.setWarehouseTotalInfo({ data });
                this.setState({
                    isDataLoaded: true,
                });
            });
    }

    onWarehouseDrop({ addedIndex, payload }) {
        const { reOrderWarehouse, filterValue, boardData } = this.props;
        const args = {
            newIndex: addedIndex,
            oldIndex: payload.sort_index,
        };
        if (filterValue) {
            if (addedIndex !== 0) {
                args.newIndex = boardData[addedIndex - 1].sort_index + 1;
            } else {
                args.newIndex = 0;
            }
        }
        reOrderWarehouse(args);
    }

    render() {
        const { boardData, filterValue } = this.props;

        return (
            <div className={s.boardWrapper}>
                <BoardHeader />
                {this.state.isDataLoaded && (
                    <div className={s.board}>
                        <Container
                            orientation="horizontal"
                            getChildPayload={(index) => boardData[index]}
                            behaviour="contain"
                            onDrop={this.onWarehouseDrop}
                            nonDragAreaSelector=".nonDrag"
                            dropPlaceholder={warehouseDropPlaceholder}
                        >
                            {boardData.map((item, index) => (
                                <Draggable data-id="warehouse" key={item.id}>
                                    <WarehouseContainer
                                        warehouseIndex={index}
                                        warehouseData={item}
                                    />
                                </Draggable>
                            ))}
                            {/* значение фильтра обрабатывается функцией .trim(), дополнительная проверка на пробелы не требуется */}
                            {boardData.length === 0 && filterValue && (
                                <div>
                                    <span className={s.noResults}>
                                        {i18next.t('SearchModal.return.notFound.error')}
                                    </span>
                                </div>
                            )}
                        </Container>
                        <AddWarehouseButtonContainer />
                    </div>
                )}
                <Toast message={i18next.t('Board.render.Toast.message')} />
                <MoveInventoryItemQuantityModal />
            </div>
        );
    }
}

const BoardTableContainer = (props) => {
    const board = useSelector((state) => state.board);
    const filter = useSelector((state) => state.filter);
    const filteredBoard = useMemo(() => {
        if (!filter) {
            return board;
        }

        return board.filter((warehouse) =>
            warehouse.items.some((inventory) =>
                inventory.title.toLowerCase().includes(filter.toLowerCase())
            )
        );
    }, [board, filter]);

    const dispatch = useDispatch();
    const reOrderWarehouse = useCallback(
        (payload) => {
            dispatch(reOrderWarehousePosition(payload));
        },
        [dispatch]
    );

    const onEquipmentDataLoaded = useCallback(
        (payload) => {
            dispatch(loadEquipmentData(payload));
        },
        [dispatch]
    );

    const setCurrency = useCallback(
        (payload) => {
            dispatch(setCurrencyValue(payload));
        },
        [dispatch]
    );

    const setAccess = useCallback(
        (payload) => {
            dispatch(setAccessValue(payload));
        },
        [dispatch]
    );

    const setWarehouseTotalInfo = useCallback(
        (payload) => {
            dispatch(loadWarehouseTotalInfo(payload));
        },
        [dispatch]
    );

    const filterValue = useSelector((state) => state.filter);

    return (
        <BoardTable
            {...props}
            reOrderWarehouse={reOrderWarehouse}
            boardData={filteredBoard}
            onEquipmentDataLoaded={onEquipmentDataLoaded}
            setCurrency={setCurrency}
            setAccess={setAccess}
            filterValue={filterValue}
            setWarehouseTotalInfo={setWarehouseTotalInfo}
        />
    );
};

export const Board = () => (
    <div className={cls.root}>
        <BoardTableContainer />
        <div id="overlay_root" />
        <ReactTooltip className={cls.tooltipTheme} arrowColor="transparent" />
    </div>
);
